import Identity from './Identity';

const IdentitySDK = {
  Identity,
};

export { Identity };

export default IdentitySDK;
